import noContextMenu from './noContextMenu'

const CANCEL_THRESHOLD = 24
const DEFAULT_OPTS = {
	scrollCancel: true
}

function parseEvent(event, touchId = null) {
	if (event.touches) {
		// Touch event
		if (!touchId) return event.touches[0]
		return Object.values(event.touches).find(t => {
			return t.identifier === touchId
		})
	} else {
		// Mouse event
		return event
	}
}

export default function button(options = DEFAULT_OPTS) {
	return {
		data() {
			return {
				pressed: false,
				pressEvent: null
			}
		},
		methods: {
			onDown(event) {
				if (this.disabled) return

				this.pressEvent = parseEvent(event)
				this.pressed = true
				this.$emit('down', event)
			},
			onMove(event) {
				// Do nothing if not pressed
				if (!this.pressed || this.disabled) return

				// Emit drag event
				this.$emit('drag', event)

				if (options.scrollCancel) {
					const evt = parseEvent(event, this.pressEvent.identifier)
					if (evt) {
						// Cancel if pointer moved too far up or down
						const dy = Math.abs(evt.clientY - this.pressEvent.clientY)
						if (dy >= CANCEL_THRESHOLD) this.pressed = false
					}
				}
			},
			onUp(event) {
				// Only finish press if pressed and not disabled
				if (!this.pressed || this.disabled) return

				// Stop browsers firing their own fake click events
				event.preventDefault()

				this.pressed = false
				this.$nextTick(() => {
					this.$emit('click', event)
				})
			}
		},
		// Animate button press on mouse/touch
		mounted() {
			this.$el.addEventListener('touchstart', this.onDown)
			window.addEventListener('touchmove', this.onMove)
			window.addEventListener('touchend', this.onUp, { passive: false })

			this.$el.addEventListener('mousedown', this.onDown)
			window.addEventListener('mousemove', this.onMove)
			window.addEventListener('mouseup', this.onUp)
		},
		beforeDestroy() {
			this.$el.removeEventListener('touchstart', this.onDown)
			window.removeEventListener('touchmove', this.onMove)
			window.removeEventListener('touchend', this.onUp)

			this.$el.removeEventListener('mousedown', this.onDown)
			window.removeEventListener('mousemove', this.onMove)
			window.removeEventListener('mouseup', this.onUp)
		},
		mixins: [noContextMenu]
	}
}
